import { YesNoOptions } from './bool-field'

export const ElevatorTypes = [
  'Vertical Reciprocating Conveyor',
  'Direct Hydraulic Elevator',
  'Dumbwaiter',
  'Electric Geared Elevator',
  'Electric Gearless Elevator',
  'Escalator',
  'Inclined Elevator Lift',
  'Private Residence Elevator',
  'LULA',
  'Moving Walk',
  'Rack and Pinion',
  'Roped Hydraulic Elevator',
  'Wheelchair Lift',
  'Wind Turbine Elevator',
  'Stage Lift',
  'Material Lift',
] as const
export type ElevatorTypes = (typeof ElevatorTypes)[number]

export const MonthOptions = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const
export type MonthOptions = (typeof MonthOptions)[number]

export const DriveTypeOptions = [
  'Hydraulic',
  'Traction',
  'Roped Hydraulic',
  'Drum',
  'Chain',
  'Screw',
  'Rack and Pinion',
  'Other',
  // TODO: Omitted Spiralift and Rigid Chain as they are in the DriveType2 value list
] as const

export const MotorControllerOptions = [
  'Motor Generator',
  'SCR Drive',
  'VVVF Drive',
  'VVAC Drive',
  'PWM Drive',
  'Across the Line',
  'Wye-Delta',
  'Soft Start',
] as const

export const GovernorTypeOptions = ['Jaw', 'Friction', 'WRGS', 'N/A'] as const

export const BrakeTypeOptions = ['Disc', 'Drum', 'N/A'] as const

export const BrakeTypeOptionsNoNA = ['Disc', 'Drum'] as const

export const ACOPUMDTypeOptions = [
  'Rope Gripper',
  'Sheave Brake',
  'N/A',
] as const
export type ACOPUMDTypeOptions = (typeof ACOPUMDTypeOptions)[number]

export const ConditionOptions = [
  'Mint',
  'Very Good',
  'Good',
  'Fair',
  'Bad',
  'Very Bad',
  'Worst',
] as const

export const AccumulatedWearOptions = [
  'No Wear',
  'Slight',
  'Noticeable',
  'Very Evident',
  'Worn',
  'Very Worn',
  'Replace',
] as const

export const DesignOptions = [
  'Best',
  'Great',
  'Good',
  'Fair',
  'Just OK',
  'Poor',
  'Very Poor',
] as const

export const InherentQualityOptions = [
  'Highest',
  'Great',
  'Good',
  'Fair',
  'Just OK',
  'Poor',
  'Lowest',
] as const

export const TechnologyOptions = [
  'Computer',
  'TTL/DTL',
  'Ice Cube Relay',
  'Open Relay',
  'Carbon Relay',
  'Phenolic Board',
  'Slate Board',
  'N/A',
  // TODO: N/A should be allowed in some cases, but not others.
] as const

export const EnvironmentOptions = [
  'Very clean',
  'Mostly clean',
  'Dusty',
  'Grimy',
  'Dirty',
  'Very Dirty',
  'Filthy/Salty',
] as const
export type EnvironmentOptions = (typeof EnvironmentOptions)[number]

export const UsageOptions = [
  'ADA',
  'Small Apartment/Condo',
  'Large Apartment/Condo',
  'Small Office < 20 floors',
  'Large Office > 20 floors',
  'Observation',
  'Medical/Convalescent',
] as const

export type UsageOptions = (typeof UsageOptions)[number]

export const TypeOfUseOptions = [
  // TODO: There's a TypeOfUseNoSpace value list which removes N/A .
  'Passenger',
  'Service',
  'Freight',
  'Commercial',
  'Industrial',
  'Transit',
  'Special Purpose',
] as const

export type TypeOfUseOptions = (typeof TypeOfUseOptions)[number]

export const SuspensionMeansOptions = [
  'Steel Wire Rope',
  'Coated Steel Belt',
  'Coated Carbon Fiber Belt',
  'Coated Aramid Fiber Belt',
  'Aramid Rope',
  'Vacuum',
  'Chain',
  'Aircraft Cable',
  'Hydraulic',
  'Screw',
] as const

export const DoorPanelsTypeOptions = [
  'Single-speed Side Opening',
  'Single-speed Center Opening',
  'Two-speed Side Opening',
  'Two-speed Center Opening',
  'Vertical Bi-parting Doors',
  'Swing',
] as const
export type DoorPanelsTypeOptions = (typeof DoorPanelsTypeOptions)[number]

export const CarDoorRestrictorTypeOptions = [
  'Door Restrictor',
  'Car Door Interlock',
  'None',
] as const
export type CarDoorRestrictorTypeOptions =
  (typeof CarDoorRestrictorTypeOptions)[number]

export const GuideTypeOptions = ['Slide', 'Roller'] as const

export const DoorOperatorOptions = ['Harmonic', 'Linear', 'Manual'] as const

export const CarDoorTypeOptions = [
  'Horizontally Sliding',
  'Vertically Sliding',
  'Swinging',
  'Scissor',
] as const

export const HoistwayDoorTypeOptions = [
  'Horizontally Sliding',
  'Vertically Sliding',
  'Swinging',
] as const
export type HoistwayDoorTypeOptions = (typeof HoistwayDoorTypeOptions)[number]

export const DoorOpeningMethodOptions = [
  'Automatic',
  'Constant Pressure',
  'Manual',
] as const

export const NumberOfCarOpeningsOptions = ['1', '2', '3', '4', '5+'] as const

export const BufferTypeOptions = [
  'Oil',
  'Spring',
  'Bumper',
  'Elastomeric',
  'N/A',
  // TODO: There's a BufferTypeNoSpace value list which removes N/A.
] as const

export const MastTypeOptions = ['Two Bolt', 'Three Bolt', 'Four Bolt'] as const
export type MastTypeOptions = (typeof MastTypeOptions)[number]

export const TravelingCableTypeOptions = ['Trolley', 'Trailing'] as const

export { YesNoOptions }

export const ManufacturersOptions = [
  'AEMA',
  'Alamak',
  'Avanti',
  'Baxter',
  'Canton',
  'Concord',
  'Dover',
  'Elevator Controls',
  'ESCO',
  'Flexlift',
  'GAL',
  'Gala',
  'Garaventa',
  'GE',
  'General',
  'Gillespie',
  'Goian',
  'Goracon',
  'Hailo',
  'Hitachi',
  'Imperial',
  'Leroy-Somers',
  'Kone',
  'Matot',
  'Mitsubishi',
  'Montgomery',
  'Montgomery Kone',
  'Motion Controls',
  'National Wheel-o-vator',
  'Otis',
  'Pflow Industries',
  'Porch Lift',
  'Reliable',
  'Rotary',
  'Savaria',
  'Schindler',
  'ThyssenKrupp',
  'ThyssenKrupp Access',
  'Thompson',
  'TL Shields',
  'Tractel',
  'US Elevator',
  'Virginia',
  'Westinghouse',
  'Zargas',
] as const
export type ManufacturersOptions = (typeof ManufacturersOptions)[number]

// MCP-285: Controller manufacturer/model list sourced from FileMaker, verified
// by John Koshek. Sorted alphabetically. Users may type a custom value if
// their controller is not listed; custom values are not persisted back to this
// list.
export const ControllerModelOptions = [
  'Alimak ALCII Controller',
  'Alimak SE 4 FC',
  'Alimak SExx DOL',
  'Amtech Reliable Hydro Simplex',
  'Amtech Reliable Omega 1000 Hydraulic',
  'Armor Activator 400',
  'Armor Dynaglide',
  'Armor TMS 900x',
  'Atel Relay Logic Hydraulic',
  'CEC SWIFT 5000',
  'CEC SWIFT Futura VCD',
  'Cemco Lift DHYD',
  'Cemco Lift HYDPC',
  'Cetek Flex-T Controller',
  'Cetek TLM',
  'Champion US 1000',
  'Champion US 2000',
  'Champion US 2500',
  'Champion US 80',
  'Champion US 900',
  'Coast Relay',
  'Concord KWIKLIFT 6000',
  'Conquest Hydraulic Controller',
  'Dover AIMIE',
  'Dover Composite',
  'Dover DMC',
  'Dover LMT',
  'Dover Micro Modernizer',
  'Dover SS Hydro',
  'Dover SS5T',
  'Dover T II',
  'Dover T III',
  'Dover T IV',
  'Dover TAC 20',
  'Dover TAC 50',
  'Dover WCR Hydro',
  'Elevator Concepts',
  'Elevator Controls H 800',
  'Elevator Controls H 900',
  'Elevator Controls Pixel Electric',
  'Elevator Controls Pixel Hydro',
  'Elevator Controls Prodigy V900',
  'Elevator Controls V 700',
  'Elevator Controls V 800',
  'Elevator Controls V 900',
  'Elevator Dynamics Eledyne 1',
  'Elevator Industries E. D. G. E.',
  'Elevator System HYD',
  'Elevator System VV',
  'ERC AC',
  'ERC ERM 6000S',
  'ERC ERM 6006',
  'ERC L1A Series',
  'ERM',
  'Fujitech -MHYDS/MHYD',
  'Fujitech EXDN',
  'Fujitech MACGL',
  'Fujitech MCOP',
  'Fujitech MDCGL',
  'Fujitech Millenium',
  'Fujitech Unico',
  'Fujitech VRDN',
  'GAL 8SX',
  'GAL Dynalift',
  'GAL Galaxy 9GX',
  'GAL Galaxy IV',
  'GAL Galaxy 10GX',
  'GAL Galaxy 11GX',
  'GAL Galaxy 12GX',
  'GAL Galaxy 13GX',
  'GAL Galaxy 15GX',
  'GAL Galaxy 8GX',
  'Geda SH2750',
  'Humphrey SAH',
  'Hyundai LX501',
  'Kone KCM 831',
  'Kone KCP 931',
  'Kone Miprom',
  'Kone Miprom 21',
  'Kone Resolve 100',
  'Kone Resolve 20',
  'Kone Resolve 400',
  'Kone Spectron',
  'Kone SSC 6010',
  'Kone SWEO 90V',
  'Kone TMS 50',
  'Kone Ultron',
  'MCE HMC 1000',
  'MCE HMC 2000',
  'MCE i-AC 01',
  'MCE i-AC 02',
  'MCE i-DC 01',
  'MCE i-DC 02',
  'MCE ICE AC-MAG',
  'MCE IMC AC',
  'MCE M4000',
  'MCE SCE-HY',
  'MCE VFMC 1000',
  'MCE VVMC 1000',
  'Mid-American VVVF',
  'Millar CVT',
  'Mitsubishi CCD-GUHx',
  'Mitsubishi CCP-GULx',
  'Mitsubishi GPQx',
  'Mitsubishi VFCL',
  'Mitsubishi VFDL',
  'Mitsubishi VFGLC',
  'Mitsubishi VFHW',
  'Mitsubishi VFMW/VFCL',
  'Mitsubishi VFMWA/VFHWA',
  'Northern M 3200 SCR',
  'Northern Normic 100 VVVF',
  'Northern Normic 1600 VV/SCR/VVVF',
  'Northern Normic 3200',
  'Northern Normic 3216',
  'Northern Northstar 9000',
  'Northern TC 181',
  'Northern TC 3200',
  'Northern TCI 181 (ELD)',
  'Nova Relay',
  'O Thompson CVT',
  'O Thompson G',
  'O Thompson MF',
  'Otis 10/20 Ux',
  'Otis 211',
  'Otis 30',
  'Otis 311',
  'Otis 45',
  'Otis 62',
  'Otis 65',
  'Otis 69',
  'Otis 70',
  'Otis 73',
  'Otis 79',
  'Otis ABA21305',
  'Otis C Base',
  'Otis DCSS',
  'Otis E2',
  'Otis E335M',
  'Otis E411',
  'Otis Elevonic 101 & 401',
  'Otis Elevonic 311',
  'Otis Elevonic 411',
  'Otis Elevonic R Series',
  'Otis GAMMA',
  'Otis GCS',
  'Otis HOCL/HCL',
  'Otis LRV III',
  'Otis LRV4',
  'Otis LRVF',
  'Otis MRQ (Spec 60)',
  'Otis MRVF',
  'Otis/LG Di-2',
  'Raxtar RX',
  'Savaria Orion, Hydraulic',
  'Schindler 300A',
  'Schindler 321A',
  'Schindler 330A',
  'Schindler CO-NX 100-NA',
  'Schindler Miconic A ACVF',
  'Schindler Miconic A SSDC',
  'Schindler Miconic GX',
  'Schindler Miconic HX',
  'Schindler Miconic TXR5',
  'Schindler Miconic V',
  'Schindler Miconic VX/TX',
  'Schindler MPH II',
  'Schindler NX-100',
  'Schumacher Micro Speed',
  'Schumacher PLC Controller',
  'Serge PCI 129x',
  'Serge PCI 2Ax',
  'Serge PCT 25 & PC225',
  'Serge PCT 28x',
  'Serge PCTMD, PCTML, PC2MD',
  'Smartrise SRA',
  'Smartrise SRD',
  'Smartrise SRH',
  'Stannah 260',
  'Stannah 420',
  'Star Delta AC',
  'Star Delta MP',
  'Star Delta Relay',
  'Star Delta SM 116',
  'STROS HS 1200',
  'STROS HS 2700',
  'Thames Valley SE 1200',
  'Thyssenkrupp ICON',
  'Thyssenkrupp ISIS',
  'Thyssenkrupp TAC 20',
  'Thyssenkrupp TAC 20-03',
  'Thyssenkrupp TAC 22',
  'Thyssenkrupp TAC 32',
  'Thyssenkrupp TAC 50',
  'Thyssenkrupp TAC 50-03',
  'Thyssenkrupp TAC 50-04',
  'US Elevator ASCENSION 1000',
  'US Elevator ASCENSION 2000',
  'US Elevator MP 1220',
  'US Elevator MP 1230',
  'Vertitron 1000',
  'Vertitron AC',
  'Vertitron VCS 1',
  'Vertitron VCS 2',
  'Vertitron VHC-102',
  'Vertitron VMI',
  'Virginia Controls MCLVV',
  'Virginia Controls MDCD',
  'Virginia Controls MH',
  'Virginia Controls Micro SSAC',
  'Virginia Controls MVFAC',
  'Virginia Controls MVFCL',
  'Virginia Controls MVFPM',
  'Voyager LVC 100',
  'Westinghouse CDM',
  'Westinghouse DMR',
  'Westinghouse Epoch 1',
  'Westinghouse Epoch 2',
  'Westinghouse ERL 10',
  'Westinghouse ERL 11',
  'Westinghouse ERL 12',
  'Westinghouse HY',
  'Westinghouse REL',
  'Westinghouse RSBL',
  'Westinghouse SMF3',
  'Westinghouse SMF4',
  'Westinghouse TTL',
] as const
export type ControllerModelOptions = (typeof ControllerModelOptions)[number]

// MCP-285: Control valve manufacturer/model list provided by Adam Duren on
// 2026-04-30 (Linear comment). Sorted alphabetically. Users may type a custom
// value if their valve is not listed; custom values are not persisted back to
// this list.
export const ControlValveModelOptions = [
  'Blain EV4',
  'Bucher LRV-1',
  'Dover I2/I3',
  'Dover P125',
  'Dover P66',
  'EECO UV 3',
  'EECO UV 4',
  'EECO UV 4R',
  'EECO UV 5AT',
  'EECO UV 5ATC',
  'EECO UV 7B',
  'EECO UV 7BC',
  'Maxton UC1',
  'Maxton UC1A',
  'Maxton UC2',
  'Maxton UC2A',
  'Maxton UC4E1',
  'Maxton UC4ME1',
  'Maxton UC4ME2',
  'Maxton UC4MRE1',
  'Maxton UC4MRE2',
  'Maxton UC4MRSTD',
  'Maxton UC4MSTD',
  'Maxton UC4STD',
  'Thyssenkrupp I2/I3',
] as const
export type ControlValveModelOptions = (typeof ControlValveModelOptions)[number]

// MCP-285: Door operator manufacturer/model list provided by Adam Duren on
// 2026-04-30 (Linear comment). Sorted alphabetically. Users may type a custom
// value if their door operator is not listed; custom values are not persisted
// back to this list.
export const DoorOperatorModelOptions = [
  'Dover - DC 68',
  'Dover - HD 73',
  'GAL - MOD',
  'GAL - MOH',
  'GAL - MOM',
  'GAL - MOVFR',
  'Kone - G2M',
  'Kone - MAC',
  'Montgomery - HPM SSC',
  'Montgomery - MAC',
  'Montgomery - WG',
  'Otis - 30S',
  'Otis - 6970',
  'Otis - 7300',
  'Otis - 7660',
  'Otis - 7700',
  'Otis - 7777',
  'Otis - A',
  'Otis - AB',
  'Otis - AT400',
  'Otis - Black Belt',
  'Otis - F',
  'Otis - HPLIM OVL',
  'Otis - IMotion',
  'Otis - O',
  'Otis - QL',
  'Thyssenkrupp - HD 02',
  'Thyssenkrupp - HD 03',
  'Thyssenkrupp - HD 04',
  'Thyssenkrupp - HD 91',
  'Thyssenkrupp - HD LM',
  'Thyssenkrupp - LD 03',
  'Thyssenkrupp - LD 92',
  'Thyssenkrupp - SmartTech',
  'Westinghouse - E5',
  'Westinghouse - EZ',
  'Westinghouse - HY',
] as const
export type DoorOperatorModelOptions = (typeof DoorOperatorModelOptions)[number]
